export default __webpack_public_path__ + "static/media/decisiveness.d430bad1.svg";